export const PRODUCT_ENDPOINT = '/product';
export const PRODUCT_TYPE_ENDPOINT = '/product-type';
export const BRAND_ENDPOINT = '/brand';
export const WARRANTY_POLICY = '/warranty-policy';
export const PURCHASE_ORDER = '/purchase-order';
export const SUPPLIER = '/supplier';
export const CUSTOMER_ENDPOINT = '/customer';
export const RECEIPT_ENDPOINT = '/receipt';
export const INVOICE_ENDPOINT = '/invoice';
export const INVOICE_REFUND_ENDPOINT = '/invoice-refund';
export const WARRANTY_ENDPOINT = '/warranty-card';
export const BRANCH_ENDPOINT = '/branch';
export const INVENTORY_REPORT = '/inventory-report';
export const REPORT_ENDPOINT = '/report';
export const TEMPLATE = '/template/print';
export const INVOICE_REPORT = '/invoice-report';

